import { render, staticRenderFns } from "./pop-up_Whatsapp.vue?vue&type=template&id=2c339d98&scoped=true&"
import script from "./pop-up_Whatsapp.vue?vue&type=script&lang=js&"
export * from "./pop-up_Whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./pop-up_Whatsapp.vue?vue&type=style&index=0&id=2c339d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c339d98",
  null
  
)

export default component.exports